import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { SitePermitStatus } from '~/client/graph/types.generated'

interface IProps {
  isLeftArrow: boolean
  status: string
}

const DONE_STATUSES: string[] = [SitePermitStatus.Done, SitePermitStatus.Ended]

export default LogisticsTimelineArrow
function LogisticsTimelineArrow({ isLeftArrow, status }: IProps): JSX.Element {
  const isDone = DONE_STATUSES.includes(status)

  return (
    <div
      className={classList({
        'row y-center timeline-arrow-holder ba-transparent absolute': true,
        'left-0': isLeftArrow,
        'right-0': !isLeftArrow,
      })}
    >
      <div
        className={classList({
          'arrow absolute tw:p-[3px]': true,
          left: isLeftArrow,
          right: !isLeftArrow,
          blue: !isDone,
          white: isDone,
        })}
      />
    </div>
  )
}
